const aggregationSort = (a, b) => a.date.localeCompare(b.date);
const resourceSort = (a, b) => b.previous + b.current - (a.previous + a.current);
function totalAggregationSort(a, b) {
  const [prevA, currA] = a.entity?.aggregation ?? [0, 0];
  const [prevB, currB] = b.entity?.aggregation ?? [0, 0];
  return prevB + currB - (prevA + currA);
}

export { aggregationSort, resourceSort, totalAggregationSort };
//# sourceMappingURL=sort.esm.js.map
